import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'

import VideoPlayer from 'modules/trainings/components/VideoPlayer'
import {
  contentContainer,
  titleStyle,
  videoContainer,
} from 'modules/trainings/components/content/styles.vanilla.css'
import { ContentViewProps } from 'modules/trainings/components/content/types'
import { VideoBlock } from 'modules/trainings/lib/content/VideoBlock'

export const VideoBlockView = ({ contentItem }: ContentViewProps<VideoBlock>) => (
  <Box gap="s24" width="full" alignItems="center">
    <Box width="full" className={contentContainer}>
      <F0Text content={contentItem.title} variant="body" style={titleStyle} />
    </Box>

    {contentItem.video.url && (
      <Box width="full" className={videoContainer}>
        <VideoPlayer src={contentItem.video.url} />
      </Box>
    )}
  </Box>
)
